import { _CHAT_ID, _TG_TOKEN_BOT,
	     _TG_URL,_CMS_URL } from "./constants"


async function sendDataTelegramm(message){
	try {
		return await fetch(_TG_URL,{
			method: "POST",
			headers:{"Content-Type" : "application/json"},
			body: JSON.stringify({
				chat_id: _CHAT_ID,
				text: message,
				parse_mode: "html"
			}),
		})
	} catch (error) {
		return error
	}
}

async function getDataFromCMS(route) {
	try {
		let res = await fetch(_CMS_URL + route)
		let data = await res.json()
		return data

	} catch (error) {
		return null
	}

}


async function getDataByLink(route, linkName) {
	try {
		const filterData = {
			link: linkName
		}
		const encodedUri = encodeURIComponent(JSON.stringify(filterData))
		let res = await fetch(_CMS_URL + route + `?filter=${encodedUri}`)
		let data = await res.json()
		return data
	} catch (error) {
		return error
	}
}


export{sendDataTelegramm, getDataFromCMS, getDataByLink}